"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeHtmlText;
/**
 * Utility to clean and normalize text content in arrays by:
 * 1. Stripping HTML tags.
 * 2. Removing extra spaces, newlines, and tabs.
 * 3. Normalizing spaces to a single space.
 *
 * @param arr - Array of strings to be cleaned.
 * @returns A new array with cleaned strings.
 *
 * @example
 * const textArray = [
 *   "<p>\n        Ir al módulo de Ventas\n        Accede a la funcionalidad de <strong>Ventas</strong> en el asistente de <strong>wicadu</strong>.</p>",
 *   "<p>\n        Crear un nuevo pedido\n        Haz clic en el botón <strong>+</strong> ubicado en la esquina superior derecha.\n      </p>"
 * ];
 * const cleanedArray = cleanAndStripText(textArray);
 * console.log(cleanedArray);
 * // Output: ["Ir al módulo de Ventas Accede a la funcionalidad de Ventas en el asistente de wicadu.", ...]
 */
function normalizeHtmlText(items) {
  const normalize = text => text.replace(/<\/?[^>]+(>|$)/g, '').replace(/\s+/g, ' ').trim();
  return Array.isArray(items) ? items.map(normalize) : normalize(items);
}